import React, { useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import Swal from "sweetalert2";
import Api from "../../api/api";
import { useNavigate } from "react-router-dom";
import { deleteuserDevices } from './../../api/api';

const DeviceTable2 = ({ refreshTrigger }) => {
  const [userData, setUserData] = useState({ columns: [], rows: [] });
  const navigate = useNavigate();

  const fetchUserData = async () => {
    try {
      const users = await Api.fetchuserDevices();

      const columns = [
        { Header: "S No", accessor: "sno", align: "left" },
        { Header: "Username", accessor: "user_name", align: "left" },
        { Header: "Device Id", accessor: "device_id", align: "left" },
        { Header: "Action", accessor: "action", align: "center" },
      ];

      const rows = users.map((user, index) => ({
        sno: index + 1,
        device_id: user.device_id,
        user_name: user.user_name,
        action: (
          <div style={{ display: "flex", gap: "15px", justifyContent: "center" }}>
            <button
              onClick={() => handleDelete(user.id)}
              style={{
                color: "#dc3545",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontWeight: "500",
              }}
            >
              Delete
            </button>
          </div>
        ),
      }));

      setUserData({ columns, rows });
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        await Api.deleteuserDevices(id);
        Swal.fire("Deleted!", "Device has been deleted.", "success");
        fetchUserData();
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      Swal.fire("Error!", "Failed to delete device", "error");
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [refreshTrigger]);

  return (
    <>
      <DataTable
        table={userData}
        entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15] }}
        canSearch
        showTotalEntries
        isSorted={false}
      />
    </>
  );
};

export default DeviceTable2;
